import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Content,
  ModalStyled,
  TextContainer,
} from "components/Box/MessageBox/styles";

class MessageBox extends Component {
  state = { isOpen: false, text: "", fromStore: false, myStoreText: "" };

  open(text, isStore, myStoreText) {
    this.setState({
      isOpen: true,
      text: text,
      fromStore: isStore,
      myStoreText: myStoreText || "Minhas compras",
    });
  }

  close() {
    this.setState({ isOpen: false }, () => {});
  }

  closeModal(e) {
    if (!e) e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    this.close();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <ModalStyled
        open={this.state.isOpen}
        onClick={(e) => e.stopPropagation()}
        onClose={() => {
          if (!this.props.disableBackdropClose) {
            this.setState({ isOpen: false });
          }
        }}
        disableAutoFocus
        withoutBgColor={this.props.withoutBackgroundColor}
        fontSize={this.props.fontSize}
        fontWeight={this.props.fontWeight}
        alignText={this.props.textAlign}
      >
        <Container>
          <TextContainer data-testid="messagebox">
            {this.state.text}
            <Content>
              <div
                className={
                  this.props.closeButtonClass
                    ? this.props.closeButtonClass
                    : "buttonConfirm"
                }
                onClick={(e) => this.closeModal(e)}
              >
                {this.props.closeButtonText
                  ? this.props?.closeButtonText
                  : "Ok!"}
              </div>

              {this.state.fromStore && (
                <Link className="buttomStatement" to="/statement">
                  {this.state.myStoreText}
                </Link>
              )}
            </Content>
          </TextContainer>
        </Container>
      </ModalStyled>
    );
  }
}

export default MessageBox;
